<template>
    <div class="component stepper">
        <template v-if="vertical">
            <v-stepper
                    v-model="currentStep"
                    :vertical="true"
                    :non-linear="true"
            >
                <template v-for="(step, index) in steps">
                    <v-stepper-step
                            :key="`${index}-step`"
                            :complete="isStepCompleted(step)"
                            :step="index + 1"
                    >
                        <span v-html="step.text"></span>
                    </v-stepper-step>
                    <v-stepper-content
                            :key="`${index}-content`"
                            :step="index"
                    ></v-stepper-content>
                </template>
            </v-stepper>
        </template>
        <template v-else="">
            <v-stepper
                    v-model="currentStep"
                    :vertical="false"
                    :alt-labels="false"
                    :non-linear="true"
            >
                <v-stepper-header>
                    <template v-for="(step, index) in steps">
                        <v-stepper-step
                                :key="`${index}-step`"
                                :complete="isStepCompleted(step)"
                                :step="index + 1"
                        >
                            <span v-html="step.text"></span>
                        </v-stepper-step>

                        <v-divider
                                v-if="index !== steps.length -1"
                                :key="index"
                        ></v-divider>
                    </template>
                </v-stepper-header>
            </v-stepper>
        </template>
    </div>
</template>

<script type="text/babel">
    import {VDivider, VStepper, VStepperContent, VStepperHeader, VStepperItems, VStepperStep} from 'vuetify/lib'

    export default {
        name: 'components-json_page-components-stepper',
        watch: {
        },
        props: {
            steps: undefined,
            finishedSteps: {
                default() {
                    return [];
                }
            },
            id: undefined,
            vertical: {
                default() {
                    return false;
                }
            }
        },
        data() {
            return {
                currentStep: -1
            }
        },
        methods: {
            isStepCompleted(step) {
                return this.finishedSteps.indexOf(step.value) > -1;
            }
        },
        computed: {
        },
        created() {
        },
        mounted() {
        },
        beforeDestroy() {
        },
        mixins: [],
        components: {
            VStepper,
            VStepperStep,
            VStepperItems,
            VStepperContent,
            VStepperHeader,
            VDivider
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .v-stepper {
        background: transparent !important;
        box-shadow: none;
    }
</style>
